import { Skeleton } from "@mui/material";
import TableCell from "./TableCell";
import StyledTableRow from "./TableRow";

export interface TableRowsSkeletonProps {
  id: string;
  numberOfRows: number;
  columns: number;
}
export const TableRowsSkeleton = ({
  id,
  numberOfRows,
  columns
}: TableRowsSkeletonProps) => {
  return [...Array(numberOfRows)].map((_, index) => (
    <StyledTableRow
      sx={{ "& > *": { borderBottom: "unset" } }}
      key={`${id}-${index}-row`}
    >
      {[...Array(columns)].map((_, indexColumn) => (
        <TableCell
          component="th"
          scope="row"
          align="center"
          key={`${id}-${index}-${indexColumn}-cell`}
        >
          <Skeleton variant="text" width="100%" height="100%" />
        </TableCell>
      ))}
    </StyledTableRow>
  ));
};
